import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom"; 
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const ViewTyre = () => {
  useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate(); // Initialize navigate function
  const [branches, setbranches] = useState([]);
  const userName = localStorage.getItem("username"); // Default branch from storage
 const [formData, setFormData] = useState({
  tyre_seriolno : "",
  	tyre_model	: "",
    tyre_make : "",
    tyre_amount	: "",
    tyre_type	 : "",
    tyre_position	: "",
    branch	: "",
    purchased_date: "",
    tyre_enterdate: "",
    tyre_remove	: "No",
    purchased_from: "",
    userid : ""
 
   });

   const canView  = hasPermission("Tyre Details", "view");

   useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
      .then((response) => {
        setbranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);


  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/get_edit_tyre_api/${id}`
        );
        setFormData({
            tyre_seriolno : response.data.tyre_seriolno,
            tyre_model	: response.data.tyre_model,
          tyre_make : response.data.tyre_make,
          tyre_amount	: response.data.tyre_amount,
          tyre_type	 : response.data.tyre_type,
          tyre_position	: response.data.tyre_position,
          branch	: response.data.branch,
          purchased_date: response.data.purchased_date,
          tyre_enterdate: response.data.tyre_enterdate,
          tyre_remove	: response.data.tyre_remove,
          purchased_from: response.data.purchased_from 
           
        });
      } catch (error) {
        console.error("Error fetching location details:", error);
      }
    };

    fetchLocation();
  }, [id]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  const payload = {
    tyre_seriolno : formData.tyre_seriolno,
  	tyre_model	: formData.tyre_model,
    tyre_make : formData.tyre_make,
    tyre_amount	: formData.tyre_amount,
    tyre_type	 : formData.tyre_type,
    tyre_position	: formData.tyre_position,
    branch	: formData.branch,
    purchased_date: formData.purchased_date
    ? formData.purchased_date.split("T")[0] 
    : "",
  tyre_enterdate: formData.tyre_enterdate
    ? formData.tyre_enterdate.split("T")[0]
    : "",
    tyre_remove	: formData.tyre_remove,
    purchased_from: formData.purchased_from,
    userid : userName
  };
  
console.log("Submitting Payload:", payload);

 
};


  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">View Tyre</h2>
          <Link to='/tyrelisting'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Serial No :</label>
                <input
                  type="text"
                  name="tyre_seriolno"
                  value={formData.tyre_seriolno}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Entry Date:</label>
                <input
                  type="text"
                  name="tyre_enterdate"
                  value={formData.tyre_enterdate ? formData.tyre_enterdate.split("T")[0] : ""} 
                  onChange={handleChange}
                  readOnly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Model:</label>
                <input
                  type="text"
                  name="tyre_model"
                  value={formData.tyre_model}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Branch:</label>
                <input
                  type="text"
                  name="branch"
                  value={formData.branch}
                  onChange={handleChange}
                  readOnly
                />
               
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Make:</label>
                <input
                  type="text"
                  name="tyre_make"
                  value={formData.tyre_make}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Tyre Type:</label>
                <input
                  type="text"
                  name="tyre_type"
                  value={formData.tyre_type}
                  onChange={handleChange}
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Position:</label>
                <input
                  type="text"
                  name="tyre_position"
                  value={formData.tyre_position}
                  onChange={handleChange}
                  readOnly
                />
               
              </div>
              <div className="form-group">
                <label>Purchased Date:</label>
                <input
                  type="text"
                  name="purchased_date"
                  value={formData.purchased_date ? formData.purchased_date.split("T")[0] : ""} 
                  onChange={handleChange}
                  readOnly
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input
                  type="text"
                  name="purchased_from"
                  value={formData.purchased_from}
                  onChange={handleChange}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input
                  type="text"
                  name="tyre_amount"
                  value={formData.tyre_amount}
                  onChange={handleChange}
                  readOnly
                />
                  </div>
            </div>
           
            
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default ViewTyre;
 